export default __webpack_public_path__ + "static/media/create-patient.0ebc74b6.webp";